import './NotificationMessages.scss'
import React, {ReactNode} from 'react'
import getUserServiceType from '../../../../service/model/UserServiceRequestType'
import {NotificationCategoryDTO, NotificationDTO, NotificationParameterDTO} from '../../../../generated/api'

export const NotificationMessage = ({notification}: {notification: NotificationDTO}) => {
    const {category, content, parameters}: NotificationDTO = notification

    const categoryMap = new Map([
        [NotificationCategoryDTO.GuildCreationApproved, <GuildCreationAccepted guildName={content} />],
        [NotificationCategoryDTO.GuildCreationDenied, <GuildCreationDenied guildName={content} />],
        [NotificationCategoryDTO.GuildUserInvitation, <GuildInvitationRequest content={content} />],
        [NotificationCategoryDTO.ServiceRequestCompleted, <ServiceRequestDelivered parameters={parameters} />],
        [NotificationCategoryDTO.ServiceRequestCreated, <ServiceRequestCreated parameters={parameters} />],
        [
            NotificationCategoryDTO.ServiceRequestQuotationUpdate,
            <ServiceRequestQuotationUpdate parameters={parameters} />
        ]
    ])

    return (category && categoryMap.get(category)) ?? <DefaultRequest content={content} />
}

const ServiceRequestDelivered = ({ parameters }: { parameters: NotificationParameterDTO[] | undefined }) => {
    return (
        <>
            {
                parameters?.map((param: NotificationParameterDTO) => <span className="notification-parameter"><label className="bold-text">{param.label}:</label><p>{param.value}</p></span>) ?? null
            }
            <span className="notification-parameter"><label className="bold-text">Status:</label><p className="guild-creation-approved">Delivered</p></span>
            <p>The service you ordered has been delivered by the DATX team.</p>
        </>
    )
}

const ServiceRequestCreated = ({ parameters }: { parameters: NotificationParameterDTO[] | undefined }) => {
    return (
        <>
            {
                parameters?.map((param: NotificationParameterDTO) => <span className="notification-parameter"><label className="bold-text">{param.label}:</label><p>{param.value}</p></span>) ?? null
            }
            <span className="notification-parameter"><label className="bold-text">Status:</label><p className="service-request-creation">Requested</p></span>
        </>
    )
}

const ServiceRequestQuotationUpdate = ({ parameters }: { parameters: NotificationParameterDTO[] | undefined }) => {
    return (
        <>
            {
                parameters?.map((param: NotificationParameterDTO) => <span className="notification-parameter"><label className="bold-text">{param.label}:</label><p style={{color:getUserServiceType(param.value)?.color}}>
                    {getUserServiceType(param.value)?.label!=='N/A'? getUserServiceType(param.value)?.label:param.value}
                </p></span>) ?? null
            }
            <br />
            Your request for part matching service has received a quotation from the DATX team.
        </>
    )
}

const GuildCreationAccepted = ({ guildName }: { guildName: string | undefined }) => {
    return (
        <>
            Your request to <label className="bold-text">Create Guild: {guildName} </label> has been{' '}
            <span className="guild-creation-approved">approved</span>.
            <br />
            You can now access this guild by clicking on your profile and select
            the guild context.
        </>
    )
}

const GuildCreationDenied = ({ guildName }: { guildName: string | undefined }) => {
    return (
        <>
            Your request to <label className="bold-text">Create Guild: {guildName} </label> has been{' '}
            <span className="guild-creation-denied">rejected</span>.
        </>
    )
}



const GuildInvitationRequest = ({ content }: { content: ReactNode }) => {
    return <>{content}</>
}

const DefaultRequest = ({ content }: { content: ReactNode }) => {
    return <>{content}</>
}

